import React, { useEffect, useState } from "react";
import { Blacked } from "../../../../CRM/components/styles";
import { ReactComponent as ModalCloseIcon } from "../../../../assets/HomeTownIcon/ModalCloseIcon.svg";
import styled from "styled-components";
import { Input, message, Table } from "antd";
import { HomeTownRoundCheckbox } from "../../../../app/organisms/Auth/Forms/HomeTownRoundCheckbox";
import { PreviewMonitor } from "./PreviewMonitor";
import { useAdminUserInfo } from "../../../hooks/Admin/UserManage/GetAdminUserInfo";
import { useAdminUserADList } from "../../../hooks/Admin/UserManage/GetAdminUserADList";
import API from "../../../../utils/api";
import { useToken } from "../../../../app/hooks";
import { formatPhoneNumber } from "../../../../utils/ciutils";
import { MEDIA_URL } from "../../../../app/constants/APIKEYS";
import { ReactComponent as DownloadIcon } from "../assets/DownloadIcon.svg";

export const RealEstateDetail = ({
                                   realEstateId,
                                   setRealEstateId,
                                   mutateUserList,
                                 }) => {
  // -------------------- Local States --------------------
  const [premium, setPremium] = useState<number>(0);               // 1=대기, 0=회원(기존 로직 유지)
  const [premiumChangeDate, setPremiumChangeDate] = useState<string>("");

  // 서버값을 로컬에 '최초 1회'만 주입하기 위한 플래그
  const [initialized, setInitialized] = useState<boolean>(false);

  // 권한
  const [roleId, setRoleId] = useState<number | undefined>(undefined);

  // 광고 미리보기
  const [commercialId, setCommercialId] = useState<number | null>(null);

  // -------------------- Utils --------------------
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;

  // -------------------- Data --------------------
  const { adminUserInfo, mutateAdminUserInfo } = useAdminUserInfo(realEstateId);
  const { adminUserADList } = useAdminUserADList(1, 1000, realEstateId);
  const { data: token } = useToken();

  // realEstateId가 바뀌면 다시 최초 주입 가능하도록 초기화
  useEffect(() => {
    setInitialized(false);
  }, [realEstateId]);

  // adminUserInfo 수신 시 '최초 한 번만' 로컬 상태에 반영
  useEffect(() => {
    if (!adminUserInfo || initialized) return;
    setPremium(adminUserInfo?.premium ?? 0);
    setPremiumChangeDate(adminUserInfo?.premiumChangeDate ?? "");
    setRoleId(adminUserInfo?.roleId ?? 1);
    setInitialized(true);
  }, [adminUserInfo, initialized]);

  const putEditUser = () => {
    const shouldEdit = window.confirm("수정하시겠습니까?");
    if (!shouldEdit) return;

    API.put(`/admin/user/list/${realEstateId}`, token + "", {
      datas: {
        premium,
        premiumChangeDate,
        roleId: roleId,
      },
    })
        .then((res: any) => {
          if (res?.result?.success) {
            message.success("수정되었습니다");
            setRealEstateId(null);
            mutateUserList?.();
          } else {
            message.error(res?.result?.message || "실패하였습니다");
          }
        })
        .catch(() => {
          message.error("실패하였습니다");
        });
  };

  const columns = [
    {
      dataIndex: "adId",
      title: "No",
      render: (value) => (
          <div className="No." style={{ justifyContent: "center", display: "flex" }}>
            {value}
          </div>
      ),
    },
    {
      dataIndex: "title",
      title: "광고명",
      render: (value, data) => (
          <div
              className="No."
              onClick={() => setCommercialId(data?.adId)}
              style={{
                justifyContent: "center",
                display: "flex",
                cursor: "pointer",
                textDecoration: "underline",
              }}
          >
            {value}
          </div>
      ),
    },
    {
      dataIndex: "period",
      title: "광고기간",
      render: (value) => (
          <div className="type" style={{ justifyContent: "center", display: "flex" }}>
            {value}
          </div>
      ),
    },
  ];

  const handleDownload = async (url: string, name: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement("a");
      const objectUrl = URL.createObjectURL(blob);
      link.href = objectUrl;
      link.style.display = "none";
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      message.error("다운로드에 실패하였습니다.");
    }
  };

  return (
      <>
        <Blacked onClick={() => setRealEstateId(null)} />
        <ModalWrapper className={"scroll-container"}>
          <ModalHeader>
            <ModalTitle>매체주 상세</ModalTitle>
            <CloseIconSVG as={ModalCloseIcon} onClick={() => setRealEstateId(null)} />
          </ModalHeader>

          <ContentsTitle>회원정보</ContentsTitle>
          <CustomTable>
            <tbody>
            <TableRow>
              <Th>
                <ThLabel>회원명</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.name || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>아이디</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.email || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>업체명</ThLabel>
              </Th>
              <Td>{adminUserInfo?.store || "-"}</Td>
              <Th>
                <ThLabel>업종</ThLabel>
              </Th>
              <Td>{adminUserInfo?.businessType || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>주소</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.address || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>세부주소</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.detailAddress || "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>휴대폰</ThLabel>
              </Th>
              <Td>{formatPhoneNumber(adminUserInfo?.phone) || "-"}</Td>
              <Th>
                <ThLabel>가입일</ThLabel>
              </Th>
              {/* 서버 키 확인 필요: createdAt / cratedAt */}
              <Td>{adminUserInfo?.createdAt ?? adminUserInfo?.cratedAt ?? "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>사용자 관리</ThLabel>
              </Th>
              <Td>
                <div style={{ display: "flex", gap: 14 }}>
                  {/* 대기 = 1 */}
                  <HomeTownRoundCheckbox
                      text={"대기"}
                      checked={premium === 1}
                      onClick={() => {
                        setPremium(1);
                        setPremiumChangeDate(formattedDate);
                      }}
                  />
                  {/* 회원 = 0 */}
                  <HomeTownRoundCheckbox
                      text={"회원"}
                      checked={premium === 0}
                      onClick={() => {
                        setPremium(0);
                        setPremiumChangeDate(formattedDate);
                      }}
                  />
                </div>
              </Td>
              <Th>
                <ThLabel>회원전환예정일</ThLabel>
              </Th>
              <Td colSpan={3}>
                <InputText
                    placeholder={"ex. 2024-01-01"}
                    value={premiumChangeDate}
                    onChange={(e) => setPremiumChangeDate(e.target.value)}
                />
              </Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>권한관리</ThLabel>
              </Th>
              <Td colSpan={3}>
                <div style={{ display: "flex", gap: 14 }}>
                  <HomeTownRoundCheckbox
                      text={"외부"}
                      checked={roleId === 1}
                      onClick={() => setRoleId(1)}
                  />
                  <HomeTownRoundCheckbox
                      text={"매물"}
                      checked={roleId === 2}
                      onClick={() => setRoleId(2)}
                  />
                  <HomeTownRoundCheckbox
                      text={"외부+매물"}
                      checked={roleId === 3}
                      onClick={() => setRoleId(3)}
                  />
                </div>
              </Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>계좌번호</ThLabel>
              </Th>
              <Td colSpan={3}>{adminUserInfo?.account ? adminUserInfo?.account : "-"}</Td>
            </TableRow>

            <TableRow>
              <Th>
                <ThLabel>부동산중개소등록증 / 사업자등록증</ThLabel>
              </Th>
              <Td colSpan={3}>
                {Array.isArray(adminUserInfo?.fileList) &&
                adminUserInfo.fileList.some((it: any) => it?.type === "A" || it?.type === "B") ? (
                    adminUserInfo.fileList
                        .filter((it: any) => it?.type === "A" || it?.type === "B")
                        .map((item: any, index: number) => (
                            <div
                                key={`file-${index}-${item?.url || item?.name}`}
                                style={{
                                  backgroundColor: "#FAFAFC",
                                  width: "100%",
                                  height: 29,
                                  padding: "6px 8px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: 4,
                                }}
                            >
                              <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {item?.name || item?.url}
                              </div>
                              <DownloadSVG
                                  as={DownloadIcon}
                                  onClick={() => handleDownload(MEDIA_URL + item?.url, item?.name || "file")}
                              />
                            </div>
                        ))
                ) : (
                    "-"
                )}
              </Td>
            </TableRow>
            </tbody>
          </CustomTable>

          <ContentsTitle>
            노출중인 광고 <ContentsSubTitle>{`${adminUserADList?.length || 0}건`}</ContentsSubTitle>
          </ContentsTitle>

          <StyleTable columns={columns} dataSource={adminUserADList || []} pagination={false} rowKey="adId" />

          <ButtonsWrapper>
            <CancelButton onClick={putEditUser}>수정</CancelButton>
          </ButtonsWrapper>
        </ModalWrapper>

        {/* {commercialId !== null && (
        <PreviewMonitor setCommercialId={setCommercialId} commercialId={commercialId} />
      )} */}
      </>
  );
};

const DownloadSVG = styled.svg`
  cursor: pointer;
  width: 16px;
`;

const InputText = styled(Input)`
  width: 160px;
  height: 28px;
  padding-left: 10px;
  border-radius: 4px;
  display: flex;

  &::placeholder {
    color: #535353;
  }
`;

const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 800px;
  width: 600px;
  min-height: 411px;
  background-color: #fff;
  overflow-y: auto;
  border-radius: 8px;
  padding: 24px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const CloseIconSVG = styled.svg`
  width: 24px;
  cursor: pointer;
`;

const ModalTitle = styled.div`
  font-family: Pretendard, sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 21.48px;
  color: #2e2559;
`;

const CustomTable = styled.table`
  width: 100%;
  margin-top: 8px;
  border-collapse: collapse;
  border: 1px solid #ccc;
`;

const TableRow = styled.tr`
  min-height: 40px;
`;

const Th = styled.th`
  padding: 10px;
  text-align: left;
  width: 20%;
  border: 1px solid #ccc;
  background-color: #f4f2ff;
  vertical-align: middle;
`;

const ThLabel = styled.div`
  font-family: Pretendard, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 16.71px;
  color: #00000099;
`;

const Td = styled.td`
  padding: 10px;
  text-align: left;
  border: 1px solid #ccc;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.71px;
`;

const ContentsTitle = styled.div`
  width: 100%;
  margin-top: 20px;
  font-family: Pretendard, sans-serif;
  font-weight: 600;
  font-size: 15px;
  line-height: 17.9px;
  color: #000000cc;
  display: flex;
  gap: 8px;
`;

const ContentsSubTitle = styled.div`
  font-family: Pretendard, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.75px;
  color: #000000cc;
`;

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 6px;
`;

const CancelButton = styled.div`
  width: 100px;
  height: 40px;
  padding: 11px;
  border: 1px solid #000000;
  color: #000000;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 500;
  font-size: 15px;
  line-height: 17.9px;
  font-family: Pretendard, sans-serif;
`;

const StyleTable = styled(Table)`
  width: 532px;
  .ant-table-thead > tr > th {
    background-color: #f5f5f5;
    color: #00000099;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.71px;
    text-align: center;
  }
`;
